import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { Provider } from 'react-redux';

import CssBaseline from '@mui/material/CssBaseline';
// styles
import './index.css';
import './theme/tailwind.css';

// configs
import router from '@configs/router';
import store from '@configs/store/index';
import AppTheme from '@configs/theme/AppTheme';
import AppNativeLayout from '@components/ui/app-layout';

// Register your router for maximum type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <AppTheme>
        <CssBaseline />
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </AppTheme>
    </StrictMode>
  );
}
